export enum EventEnum {
  TKD = 'TKD',
  MANUALNY = 'MANUALNY',
}

export enum EventModEnum {
  WEJSCIE = 'WEJSCIE',
  WYJSCIE = 'WYJSCIE',
}

export enum EventModeEnum {
  ZWYKLE = 1,
  PRYWATNE,
  SLUZBOWE,
  SPECJALNE,
  DEFINED_5,
  DEFINED_6,
  DEFINED_7,
  DEFINED_8,
  DEFINED_9,
  DEFINED_10,
  DEFINED_11,
}

export enum EventEntryStateEnum {
  BRAK = 'BRAK',
  DRZWI_OTWARTE = 'DRZWI_OTWARTE',
  DRZWI_NIEOTWARTE = 'DRZWI_NIEOTWARTE',
}

/**
 * WKD-2422: category of an "Inne" (tryb-0) event.
 * - NIEUPRAWNIONA — card issued but has no effective permission (or is blocked)
 * - NIEWYDANA — card exists in the WebKD DB but is not assigned to a holder
 * - OBCA — card is not present in the WebKD DB at all
 */
export enum EventCategoryEnum {
  NIEUPRAWNIONA = 'NIEUPRAWNIONA',
  NIEWYDANA = 'NIEWYDANA',
  OBCA = 'OBCA',
}
